module.exports = "/_next/static/images/customer-review-magdalena-min-438285e2f9ea0331d73caa41090ae51e.png";